import { FC } from 'react';
import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { LockClosedFilledSize16 } from '@hh.ru/magritte-ui-icon/icon';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import { SwitchSkeleton } from '@hh.ru/magritte-ui-switch/Skeleton';
import { SwitchProps } from '@hh.ru/magritte-ui-switch/types';

import styles from './switch.less';

const SwitchComponent: FC<SwitchProps> = ({
    onClick,
    'aria-label': ariaLabel,
    disabled = false,
    checked = false,
    ...props
}) => {
    const forceDisabled = useDisabled();

    const switchClasses = classnames(styles.switch, {
        [styles.checked]: checked,
    });

    return (
        <button
            {...props}
            type="button"
            className={switchClasses}
            onClick={onClick}
            disabled={forceDisabled || disabled}
            aria-checked={checked}
            aria-label={ariaLabel}
            role="switch"
        >
            <span className={styles.slider}>{(forceDisabled || disabled) && <LockClosedFilledSize16 />}</span>
        </button>
    );
};

export const Switch = enrichWithSkeleton(SwitchComponent, SwitchSkeleton);
